import { HeroConsolidatedProps } from 'libs/contentful/props';
import { Margins } from 'types/constants';
import { PropsWithChildrenAndClass } from 'types/sharedComponents';
import { cn, getColorway } from 'utils/styles';

interface HeroWrapperPops
  extends PropsWithChildrenAndClass,
    Pick<HeroConsolidatedProps, 'color' | 'margins' | 'sectionName' | 'isInactiveCarouselSlide'> {
  innerClassName?: string;
  testId?: string;
}

const HeroWrapper = ({
  children,
  color,
  margins,
  className,
  sectionName,
  innerClassName,
  testId,
  isInactiveCarouselSlide,
}: HeroWrapperPops) => {
  return (
    <section
      data-testid={`heroConsolidated__${testId}`}
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className={cn(
        getColorway(color),
        margins !== Margins.NoBottom ? 'py-8 sm:py-16' : 'pt-8 sm:pt-16 pb-0',
        className,
      )}
      inert={isInactiveCarouselSlide}>
      <div className="content-wrapper">
        <div className={cn('flex sm:flex-row flex-col gap-y-8 sm:gap-25 h-full items-stretch', innerClassName)}>
          {children}
        </div>
      </div>
    </section>
  );
};

export const HeroContentWrapper = ({ children, className }: PropsWithChildrenAndClass) => {
  return <div className={cn('sm:flex sm:flex-col sm:w-1/2 grow sm:max-w-[60%]', className)}>{children}</div>;
};

export default HeroWrapper;
